import { Box, Chip, CircularProgress, IconButton } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

export const PURCHASE_ORDER_UPDATE_STATUS = {
  not_received: { label: 'Webhook not received', color: 'warning' },
  received: { label: 'Webhook received', color: 'info' },
  processing: { label: 'Webhook processing', color: 'warning' },
  processed: { label: 'Webhook processed', color: 'success' },
  failed: { label: 'Webhook failed', color: 'error' },
}

export function webhookTriggerLabel(source) {
  if (source === 'MANUAL') return 'Triggered manually'
  if (source === 'SYSTEM') return 'Triggered by system'
  return null
}

export default function PurchaseOrderUpdateStatus({
  status,
  update,
  shipmentLabel,
  onView,
  onRequestView,
  viewLoading = false,
}) {
  const meta = PURCHASE_ORDER_UPDATE_STATUS[status]
  if (!meta) return null
  const triggerLabel = webhookTriggerLabel(update?.source)
  const canView = onRequestView ? status !== 'not_received' : Boolean(update)
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.75, flexWrap: 'wrap' }}>
      <Chip size="small" label={meta.label} color={meta.color} />
      {triggerLabel ? <Chip size="small" variant="outlined" label={triggerLabel} /> : null}
      {canView ? (
        <IconButton
          size="small"
          aria-label="View webhook"
          disabled={viewLoading}
          onClick={() => {
            if (onRequestView) onRequestView()
            else if (update) {
              onView({
                heading: `${shipmentLabel} webhook`,
                response: update,
              })
            }
          }}
        >
          {viewLoading ? <CircularProgress size={16} /> : <VisibilityIcon fontSize="small" />}
        </IconButton>
      ) : null}
    </Box>
  )
}
